<div mat-dialog-title>One more thing</div>
<div mat-dialog-content fxLayout='column'>
  <p>We need a phone number to finish creating your account.</p>
  <mat-form-field *ngIf='email'>
    <mat-label>eMail</mat-label>
    <input matInput type='email' [ngModel]='email' disabled>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Phone</mat-label>
    <input matInput placeholder='Phone (10-digit US)' type='tel' [(ngModel)]='phone' required cdkFocusInitial>
    <mat-hint>Required — e.g. (555) 123-4567</mat-hint>
  </mat-form-field>
</div>
<div mat-dialog-actions align='end'>
  <button mat-button (click)='cancel()'>Cancel</button>
  <button mat-raised-button color='accent' (click)='submit()' [disabled]='!isValid'>Continue</button>
</div>
